import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("myapple-lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("myapple-lang", lang);
    document.documentElement.lang = lang === "gr" ? "el" : "en";
  }, [lang]);

  const toggleLang = () => {
    setLang((prev) => (prev === "en" ? "gr" : "en"));
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLang must be used within a LanguageProvider");
  }
  return context;
};
